export default __webpack_public_path__ + "static/media/bg4.4561324d.jpeg";